<template>
  <IbxScopedCss style="height: 100%">
    <component
      :is="apiAccessTab"
      v-if="!GQL_useKeysQuery.loading.value"
    />
  </IbxScopedCss>
</template>

<script>
import { defineComponent } from 'vue';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { Key_StatusType, useKeysQuery } from '@/graphql/codegen/generated/graphql';
import emptyApiKey from './emptyApiKey.vue';
import generatedApiKey from './generatedApiKey.vue';

export default defineComponent({
  name: 'SettingsApiAccess',
  components: {
    IbxScopedCss,
    emptyApiKey,
    generatedApiKey,
  },
  setup() {
    const GQL_useKeysQuery = useKeysQuery({ filter: { statusFilter: Key_StatusType.Active } }); // apiKey=null means that we get the apiKey with the active status
    return { GQL_useKeysQuery };
  },
  computed: {
    APIKey() {
      return this.GQL_useKeysQuery?.result?.value?.keys.length;
    },
    apiAccessTab() {
      return !this.APIKey ? 'empty-api-key' : 'generated-api-key';
    },
  },
});
</script>

<style lang="scss"></style>
